import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import "./DealTimer.css";

const DealTimer = () => {
  // Set your target date here
  const targetDate = new Date("2025-06-09T23:59:59");

  // <<< 1. CORRECTED THE FUNCTION TO BE MORE ROBUST
  // It now defaults to all zeros if the countdown is over.
  const calculateTimeLeft = () => {
    const difference = +targetDate - +new Date();
    let timeLeft = { days: 0, hours: 0, minutes: 0, seconds: 0 }; // Default to 0

    if (difference > 0) {
      timeLeft = {
        days: Math.floor(difference / (1000 * 60 * 60 * 24)),
        hours: Math.floor((difference / (1000 * 60 * 60)) % 24),
        minutes: Math.floor((difference / 1000 / 60) % 60),
        seconds: Math.floor((difference / 1000) % 60),
      };
    }

    return timeLeft;
  };

  const [timeLeft, setTimeLeft] = useState(calculateTimeLeft());
  const [isTimerEnded, setIsTimerEnded] = useState(
    // Check if the timer is ended by seeing if all time values are zero
    Object.values(timeLeft).every((value) => value === 0)
  );

  // <<< 2. SIMPLIFIED THE useEffect LOGIC
  useEffect(() => {
    // If the timer has already ended on initial load, do nothing.
    if (isTimerEnded) return;

    const timer = setInterval(() => {
      const newTimeLeft = calculateTimeLeft();
      setTimeLeft(newTimeLeft);

      // When the timer reaches zero, update the state and stop the interval
      if (Object.values(newTimeLeft).every((value) => value === 0)) {
        setIsTimerEnded(true);
        clearInterval(timer);
      }
    }, 1000);

    // Cleanup function to clear the interval when the component unmounts
    return () => clearInterval(timer);
  }, [isTimerEnded]); // Effect depends only on isTimerEnded

  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  };

  const formatTime = (value) => {
    // Make sure value is a number before calling toString()
    return (value || 0).toString().padStart(2, "0");
  };

  return (
    <>
      <div className="mainDeal">
        <div className="dealTimer">
          <div className="dealTimerMainContent">
            <div className="dealTimeContent">
              <p>
                {isTimerEnded ? "This Deal Has Ended" : "Deal of the Week"}
              </p>
              <h3>
                Spring
                <span> Collection</span>
              </h3>
              <div className="dealTimeLink">
                <Link to="/shop" onClick={scrollToTop}>
                  {isTimerEnded ? "Explore Other Deals" : "Shop Now"}
                </Link>
              </div>
            </div>

            {isTimerEnded ? (
              <div className="dealEndedMessage">
                <h3>The deal has expired!</h3>
                <p>
                  Don't worry, you can find other great offers in our shop.
                </p>
              </div>
            ) : (
              <div className="dealTimeCounter">
                <div className="dealTimeDigit">
                  <h4>{formatTime(timeLeft.days)}</h4>
                  <p>Days</p>
                </div>
                <h4>:</h4>
                <div className="dealTimeDigit">
                  <h4>{formatTime(timeLeft.hours)}</h4>
                  <p>Hours</p>
                </div>
                <h4>:</h4>
                <div className="dealTimeDigit">
                  <h4>{formatTime(timeLeft.minutes)}</h4>
                  <p>Minutes</p>
                </div>
                <h4>:</h4>
                <div className="dealTimeDigit">
                  <h4>{formatTime(timeLeft.seconds)}</h4>
                  <p>Seconds</p>
                </div>
              </div>
            )}
          </div>
        </div>
      </div>
    </>
  );
};

export default DealTimer;